import ClubApi from '../interfaces/api';

import API_SERVICE from '../../api/api.service';
import appRequest from 'utils/request';

interface ListObject {
  list: 'regular' | 'craftsman';
}

async function invite(
  email: string,
  list: string,
  inviteTenantId: string,
): Promise<{ success: boolean; message: string }> {
  const requestBody = {
    email: email,
    list: list,
    inviteTenantId,
  };
  return await API_SERVICE.mailerController.invite.call({ requestBody });
}

/**
 * Club API definitions for production use.
 *
 * These definitions can only be covered by end-to-end (e2e) tests.
 */
async function acceptInvite(
  emailToken: string,
  list: ListObject
): Promise<{ success: boolean; message: string }> {
  return await API_SERVICE.mailerController.accept.call({
    //@ts-ignore
    parameters: { emailToken }, requestBody: { ...list } ,
  });
}

async function registerWithDiscount(
  email: string,
  inviteTenantId: string,
): Promise<{ success: boolean; message: string }> {
  const requestBody = {
    email: email,
    inviteTenantId,
  };
  const { data } = await appRequest('/promotions/register-with-discount', {
    method: 'POST',
    data: requestBody,
  });
  return data;
}

const clubApiProd: ClubApi = {
  invite,
  registerWithDiscount,
  acceptInvite,
};

export default clubApiProd;
